import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { NgbDropdown, NgbTypeahead } from '@ng-bootstrap/ng-bootstrap';
import { ToastNotificationService } from '../../core/toast-notification.service';
import { UIBlockingService } from '../../core/ui-blocking.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MakePublicPaymentRequest } from './DTOs/make-public-payment-request';
import { MemberInformationService } from '../member-information/member-information.service';
import { AuthService } from '../../core/auth.service';
import { DumbPaymentMemberListItem } from './DTOs/dumb-payment-member-list-item';
import { debounceTime, distinctUntilChanged, filter, map, merge, Observable, OperatorFunction, Subject } from 'rxjs';

@Component({
    selector: 'app-public-payments',
    templateUrl: './public-payments.component.html',

    providers: [UIBlockingService, NgbDropdown, NgbTypeahead],
    encapsulation: ViewEncapsulation.None
})

export class PublicPaymentsComponent {
    constructor(private memberInformationService: MemberInformationService,
        private blockUI: UIBlockingService,
        private notificationService: ToastNotificationService,
        private authService: AuthService,
        private route: ActivatedRoute,
        private router: Router) {
    }

    isLoggedIn = false;

    /*paymentReasons = [{ val: 2, title: 'Sponsorship' }
        , { val: 3, title: 'Accelerate Indy' }
        , { val: 10, title: 'Certificate of Origin' }
        , { val: 8, title: 'LEDO' }
        , { val: 1, title: 'Membership Dues' }
        , { val: 11, title: 'LEX Registration' }
        , { val: 9, title: 'Health Alliance Dues' }
        , { val: 12, title: 'Monumental Awards Registration' }
        , { val: 7, title: 'Other' },
    ];*/

    get paymentReasons() {
        if (this.isLoggedIn) {
            return [{ val: -1, title: '' }, { val: 12, title: 'Monumental Awards Registration' }, { val: 7, title: 'Other' }]
        }
        else {
            return [{ val: -1, title: '' }
                , { val: 3, title: 'Accelerate Indy' }
                , { val: 10, title: 'Certificate of Origin' }
                , { val: 9, title: 'Health Alliance Dues' }
                , { val: 8, title: 'LEDO' }
                , { val: 11, title: 'LEX Registration' }
                , { val: 1, title: 'Membership Dues' }
                , { val: 12, title: 'Monumental Awards Registration' }
                , { val: 2, title: 'Sponsorship' }  
                , { val: 7, title: 'Other' },
            ]
        }
    }

    dumbMembers: string[] = [];
    dumbMembersFiltered: string[] = [];

    paymentTypeCtrl = new FormControl("paymentType");

    yourNameCtrl = new FormControl("yourName", [Validators.required]);
    memoCtrl = new FormControl("memo", [Validators.maxLength(250)]);
    companyNameCtrl = new FormControl("companyName", [Validators.required]);
    phoneNumberCtrl = new FormControl("phoneNumber", [Validators.required]);
    emailCtrl = new FormControl("email", [Validators.required]);
    paymentReasonCtrl = new FormControl("paymentReason", [Validators.required, Validators.min(0)]);
    invoiceNumberCtrl = new FormControl("invoiceNumber");
    paymentAmountCtrl = new FormControl("paymentAmount", [Validators.required]);

    cardNumberCtrl = new FormControl("cardNumber");
    cardExpirationCtrl = new FormControl("cardExpiration");
    CVVCtrl = new FormControl("cvv");
    streetCtrl = new FormControl("street");
    street2Ctrl = new FormControl("street2");
    cityCtrl = new FormControl("city");
    stateCtrl = new FormControl("state");
    zipCtrl = new FormControl("zip");
    accountNameCtrl = new FormControl("accountName");
    routingNumberCtrl = new FormControl("routingNumber");
    accountNumber1Ctrl = new FormControl("accountNumber1");
    accountNumber2Ctrl = new FormControl("accountNumber2");
    password1Ctrl = new FormControl("password1");
    password2Ctrl = new FormControl("password2");

    paymentInfoForm: FormGroup = new FormGroup({

        yourName: this.yourNameCtrl,
        memo: this.memoCtrl,
        companyName: this.companyNameCtrl,
        phoneNumber: this.phoneNumberCtrl,
        email: this.emailCtrl,
        paymentReason: this.paymentReasonCtrl,
        invoiceNumber: this.invoiceNumberCtrl,
        paymentAmount: this.paymentAmountCtrl,
        paymentType: this.paymentTypeCtrl,
        cardNumber: this.cardNumberCtrl,
        cardExpiration: this.cardExpirationCtrl,
        cvv: this.CVVCtrl,
        street: this.streetCtrl,
        street2: this.street2Ctrl,
        city: this.cityCtrl,
        state: this.stateCtrl,
        zip: this.zipCtrl,
        accountName: this.accountNameCtrl,
        routingNumber: this.routingNumberCtrl,
        accountNumber1: this.accountNumber1Ctrl,
        accountNumber2: this.accountNumber2Ctrl,
        password1: this.password1Ctrl,
        password2: this.password2Ctrl
    });

    strength: number = 0;

    strengthChanged(evt: number | null) {
        this.strength = evt == null ? 0 : evt;
    }

    paymentType() { return this.paymentInfoForm.get('paymentType').value }
    makingMembershipPaymentError() { return this.paymentReason() == 1; }

    yourName() { return this.paymentInfoForm.get('yourName').value }
    companyName() { return this.paymentInfoForm.get('companyName').value }
    memo() { return this.paymentInfoForm.get('memo').value }
    phoneNumber() { return this.paymentInfoForm.get('phoneNumber').value }
    email() { return this.paymentInfoForm.get('email').value }
    paymentReason() { return this.paymentInfoForm.get('paymentReason').value }
    invoiceNumber() { return this.paymentInfoForm.get('invoiceNumber').value }
    paymentAmount() { return this.paymentInfoForm.get('paymentAmount').value }

    cardNumber() { return this.paymentInfoForm.get('cardNumber').value }
    cardExpiration() { return this.paymentInfoForm.get('cardExpiration').value }
    cvv() { return this.paymentInfoForm.get('cvv').value }
    street() { return this.paymentInfoForm.get('street').value }
    street2() { return this.paymentInfoForm.get('street2').value }
    city() { return this.paymentInfoForm.get('city').value }
    state() { return this.paymentInfoForm.get('state').value }
    zip() { return this.paymentInfoForm.get('zip').value }

    accountName() { return this.paymentInfoForm.get('accountName').value }
    routingNumber() { return this.paymentInfoForm.get('routingNumber').value }
    accountNumber1() { return this.paymentInfoForm.get('accountNumber1').value }
    accountNumber2() { return this.paymentInfoForm.get('accountNumber2').value }
    accountNumbersMatchError: boolean = false;

    passwordMismatch() { return this.pass1 !== this.pass2 };
    lowStrength() { return this.strength < 3 };
    tooShort() { return this.pass1.length < 8 };

    get showPasswordErrors() {
        if (this.pass1.length == 0 && this.pass2.length == 0) {
            return false;
        }
        if (this.lowStrength()) {
            return true;
        }
        if (this.tooShort()) {
            return true;
        }
        if (this.passwordMismatch()) {
            return true;
        }
        else {
            return false;
        }
    }

    get pass1() { return this.paymentInfoForm.get('password1')?.value };
    get pass2() { return this.paymentInfoForm.get('password2')?.value };

    ngOnInit() {
        if (localStorage.getItem('contactId')) {
            this.isLoggedIn = true;
        }
        this.resetPaymentInfoForm();
        this.getDumbPaymentMemberListItem();

    }
    getDumbPaymentMemberListItem(): void {
        this.memberInformationService.GetDumbMembersForPayment()
            .subscribe({
                next: (data) => {
                    if (data) {
                        this.dumbMembers = data;
                        this.dumbMembersFiltered = data;
                        this.search = (text$: Observable<string>) => {
                            const debouncedText$ = text$.pipe(debounceTime(200), distinctUntilChanged());
                            const clicksWithClosedPopup$ = this.click$.pipe(filter(() => !this.instance.isPopupOpen()));
                            const inputFocus$ = this.focus$;

                            return merge(debouncedText$, inputFocus$, clicksWithClosedPopup$).pipe(
                                map((term) =>
                                    (term === '' ? this.dumbMembers : this.dumbMembers.filter((v) => v?.toLowerCase().indexOf(term?.toLowerCase()) > -1)).slice(0, 10),
                                ),
                            );
                        };
                    }
                },
                error: (err) => {
                    console.log(err);
                    this.notificationService.error(err.error.message);
                    this.blockUI.stop();
                },
                complete: () => {
                    this.blockUI.stop();
                }
            });
    }

    private resetPaymentInfoForm(): void {
        this.paymentInfoForm.reset();
        this.paymentInfoForm.get('paymentType').valueChanges.subscribe(val => {
            this.clearPaymentValidators();
            this.setPaymentValidators(val);
        });
        this.paymentInfoForm.get('paymentReason').valueChanges.subscribe(val => {
            if (val != 7 && val != 12) {
                this.paymentInfoForm.get('invoiceNumber').setValidators(Validators.required);
                this.paymentInfoForm.get('invoiceNumber').updateValueAndValidity();
                this.paymentInfoForm.get('memo').clearValidators();
                this.paymentInfoForm.get('memo').updateValueAndValidity();
            }
            else {
                this.paymentInfoForm.get('invoiceNumber').clearValidators();
                this.paymentInfoForm.get('invoiceNumber').updateValueAndValidity();
                this.paymentInfoForm.get('memo').setValidators([Validators.required, Validators.maxLength(250)]);
                this.paymentInfoForm.get('memo').updateValueAndValidity();
            }
        });
        this.paymentInfoForm.patchValue({
            paymentType: 1,
            password1: "",
            password2: "",
            paymentReason: -1,
        });

        // if (this.authService.canAccessMemberOnlyContent()) {
        //   this.paymentReasons = [{ val: 7, title: 'Other' }]
        // }

    }

    setPaymentValidators(val) {
        if (val == 1) {
            this.paymentInfoForm.get('cardNumber').setValidators(Validators.required);
            this.paymentInfoForm.get('cardExpiration').setValidators(Validators.required);
            this.paymentInfoForm.get('cvv').setValidators(Validators.required);
            this.paymentInfoForm.get('street').setValidators(Validators.required);
            this.paymentInfoForm.get('city').setValidators(Validators.required);
            this.paymentInfoForm.get('state').setValidators(Validators.required);
            this.paymentInfoForm.get('zip').setValidators(Validators.required);
        }
        else if (val == 2) {
            this.paymentInfoForm.get('accountName').setValidators(Validators.required);
            this.paymentInfoForm.get('routingNumber').setValidators(Validators.required);
            this.paymentInfoForm.get('accountNumber1').setValidators(Validators.required);
            this.paymentInfoForm.get('accountNumber2').setValidators(Validators.required);
        }
        this.paymentInfoForm.get('accountName').updateValueAndValidity();
        this.paymentInfoForm.get('routingNumber').updateValueAndValidity();
        this.paymentInfoForm.get('accountNumber1').updateValueAndValidity();
        this.paymentInfoForm.get('accountNumber2').updateValueAndValidity();
        this.paymentInfoForm.get('cardNumber').updateValueAndValidity();
        this.paymentInfoForm.get('cardExpiration').updateValueAndValidity();
        this.paymentInfoForm.get('cvv').updateValueAndValidity();
        this.paymentInfoForm.get('street').updateValueAndValidity();
        this.paymentInfoForm.get('street2').updateValueAndValidity();
        this.paymentInfoForm.get('city').updateValueAndValidity();
        this.paymentInfoForm.get('state').updateValueAndValidity();
        this.paymentInfoForm.get('zip').updateValueAndValidity();
    }

    clearPaymentValidators() {
        this.paymentInfoForm.get('cardNumber').clearValidators();
        this.paymentInfoForm.get('cardExpiration').clearValidators();
        this.paymentInfoForm.get('cvv').clearValidators();
        this.paymentInfoForm.get('street').clearValidators();
        this.paymentInfoForm.get('city').clearValidators();
        this.paymentInfoForm.get('state').clearValidators();
        this.paymentInfoForm.get('zip').clearValidators();
        this.paymentInfoForm.get('routingNumber').clearValidators();
        this.paymentInfoForm.get('accountNumber1').clearValidators();
        this.paymentInfoForm.get('accountNumber2').clearValidators();
        this.paymentInfoForm.get('accountName').clearValidators();

        this.paymentInfoForm.get('accountName').updateValueAndValidity();
        this.paymentInfoForm.get('routingNumber').updateValueAndValidity();
        this.paymentInfoForm.get('accountNumber1').updateValueAndValidity();
        this.paymentInfoForm.get('accountNumber2').updateValueAndValidity();
        this.paymentInfoForm.get('cardNumber').updateValueAndValidity();
        this.paymentInfoForm.get('cardExpiration').updateValueAndValidity();
        this.paymentInfoForm.get('cvv').updateValueAndValidity();
        this.paymentInfoForm.get('street').updateValueAndValidity();
        this.paymentInfoForm.get('city').updateValueAndValidity();
        this.paymentInfoForm.get('state').updateValueAndValidity();
        this.paymentInfoForm.get('zip').updateValueAndValidity();
    }

    submitPayment() {
        for (var i in this.paymentInfoForm.controls) {
            this.paymentInfoForm.controls[i].markAsTouched();
        }
        if (this.paymentType() == 2) {
            if (this.accountNumber1() != this.accountNumber2()) {
                this.accountNumbersMatchError = true;
            }
        } else {
            this.accountNumbersMatchError = false;
        }
        if (!this.paymentInfoForm.valid || this.accountNumbersMatchError || this.showPasswordErrors) {
            return;
        }
        this.blockUI.start();


        var request = new MakePublicPaymentRequest();
        request.paymentType = this.paymentType();

        request.payeeName = this.yourName();
        request.companyName = this.companyName();
        request.memo = this.memo();
        request.phoneNumber = this.phoneNumber();
        request.email = this.email();
        request.reason = this.paymentReason();
        request.paymentAmount = this.paymentAmount();

        request.cardNumber = this.cardNumber();
        request.invoiceNumber = this.invoiceNumber();
        request.cardExpiration = this.cardExpiration();
        request.cvv = this.cvv();
        request.billingStreet = this.street();
        request.billingStreet2 = this.street2();
        request.billingCity = this.city();
        request.billingState = this.state();
        request.billingZip = this.zip();

        request.password1 = this.pass1;
        request.password2 = this.pass2;

        if (this.paymentType() == 2) {
            request.nameOnAccount = this.accountName();
        }
        else {
            request.nameOnAccount = this.yourName();
        }
        request.routingNumber = this.routingNumber();
        request.accountNumber1 = this.accountNumber1();
        request.accountNumber2 = this.accountNumber2();


        this.memberInformationService.SubmitPublicPayment(request)
            .subscribe({
                next: (data) => {
                    if (data) {
                        this.notificationService.success("Payment successfully submitted. Thank you!");
                        this.resetPaymentInfoForm();
                        window.scrollTo(0, 0);
                    }
                },
                error: (err) => {
                    console.log(err);
                    this.notificationService.error(err.error.message);
                    this.blockUI.stop();
                },
                complete: () => {
                    this.blockUI.stop();
                }
            });

    }

    //typeahead Stuff

    @ViewChild('instance', { static: true }) instance: NgbTypeahead;
    focus$ = new Subject<string>();
    click$ = new Subject<string>();

    search: OperatorFunction<string, readonly string[]>;

}
